import React, { Component } from 'react'
import shortid from "shortid";
import MyComponent from '../MyComponent';

const NewMenu = ({ containerObject, templateName, contentId, dataZone }) => {
    return (
        <li class="main-menu-item menu-item-even">
            <a class="menu-link ca-main-menu-link" href={containerObject?.attributes?.navLink ?? '#'}>{containerObject?.attributes?.displayName ?? ""}</a>
            <span class="nav-click"><i class="bi bi-bars"></i></span>
            <ul class="sub-menu menu-odd">
            <li class="sub-menu-item menu-item-odd">
                <div className="containerWarp" data-cont-id={containerObject ? containerObject.contentId : ""} data-zone="ContentFolderZone" data-zone-id="Content Rule Zone" data-page-id={containerObject ? containerObject.containerContentId : ""}>
                    <div className="primary-zone" data-zone="ContentFolderZone" >
                        <div className={"row m-0 "} data-page-id={containerObject ? containerObject.contentId : ""} data-id="zone" data-zone="ContentFolderZone"
                            plugin-name={containerObject && containerObject.contents && containerObject.contents.ContentFolderZone[0] &&
                                containerObject.contents.ContentFolderZone[0].attributes && containerObject.contents.ContentFolderZone[0].attributes.folderName} >
                            <div className="container-fluid justify-content-around gx-0 px-0"

                                data-page-id={containerObject ? containerObject.contentId : ""} data-id="zone" data-zone="ContentFolderZone">

                                {containerObject && containerObject.contents && containerObject.contents.ContentFolderZone.map(content => {
                                    let contentFolderZoneType = content['@type'];

                                    return (
                                        <MyComponent type={contentFolderZoneType} key={shortid.generate()} containerObject={content} contentId={contentId} dataZone={"ContentFolderZone"} templateName={contentFolderZoneType} parentAttributes={containerObject.attributes ? containerObject.attributes : ""} />

                                    )
                                }
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </li>
            </ul></li>

    )

}

export default NewMenu